import { render, staticRenderFns } from "./GiftMessageElement.vue?vue&type=template&id=9c201184&scoped=true&"
import script from "./GiftMessageElement.vue?vue&type=script&lang=babel&"
export * from "./GiftMessageElement.vue?vue&type=script&lang=babel&"
import style0 from "./GiftMessageElement.vue?vue&type=style&index=0&id=9c201184&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c201184",
  null
  
)

export default component.exports